import { useMemo } from "react";
import { useFilters as useTimeSheetFilters } from "../../../../TimeSheet/Home/Actions/useFilters";
import { toConfig } from "../helpers";

export const useFilters = () => {
    const filters = useTimeSheetFilters();
    return useMemo(() => toConfig(filters), [filters]);
};
